export default __webpack_public_path__ + "static/media/011-united states of america.2b95d76d.svg";